import { render, staticRenderFns } from "./DiyAdvert.vue?vue&type=template&id=6b755e38&scoped=true&"
import script from "./DiyAdvert.vue?vue&type=script&lang=js&"
export * from "./DiyAdvert.vue?vue&type=script&lang=js&"
import style0 from "./DiyAdvert.vue?vue&type=style&index=0&id=6b755e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b755e38",
  null
  
)

export default component.exports